import { render, staticRenderFns } from "./DistrictsList.vue?vue&type=template&id=73509737&scoped=true"
import script from "./DistrictsList.vue?vue&type=script&lang=js"
export * from "./DistrictsList.vue?vue&type=script&lang=js"
import style0 from "./DistrictsList.vue?vue&type=style&index=0&id=73509737&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73509737",
  null
  
)

export default component.exports